import { useState } from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ErrorState, LoadingState } from "@/components/shared/states";
import { Button } from "@/components/ui/button";
import { profileRouteState } from "@/lib/route-access";
import { useAuth } from "./auth-provider";

export function ProtectedRoute() {
  const { session, access, loading, refreshProfile } = useAuth();
  const [retrying, setRetrying] = useState(false);
  const [error, setError] = useState<unknown>(null);
  const location = useLocation();
  // Initial/account-switch loads block; same-user refreshes preserve dirty forms.
  const state = profileRouteState(
    session?.user.id ?? null,
    access?.authUserId,
    loading || retrying,
  );
  if (state === "loading")
    return (
      <div className="min-h-screen">
        <LoadingState label="Opening WINBOX WorkHub..." />
      </div>
    );
  if (state === "signed-out")
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  if (state === "unavailable")
    return (
      <div className="mx-auto max-w-xl space-y-4 p-6">
        <ErrorState
          error={
            error ??
            new Error(
              "We could not load your access profile. Try again to open your workspace.",
            )
          }
        />
        <Button
          type="button"
          onClick={async () => {
            setRetrying(true);
            try {
              await refreshProfile();
              setError(null);
            } catch (failure) {
              setError(failure);
            } finally {
              setRetrying(false);
            }
          }}
        >
          Try loading profile again
        </Button>
      </div>
    );
  return <Outlet />;
}
